export default {
  getRespondents: state => state.respondents
}
